export { browser as default } from '../src/browser';
